import { generateMedia } from 'styled-media-query'
import { mediaConfig } from '~/types/consts'

export default generateMedia(mediaConfig)
